import {SubscriberModel} from '@/subscriber/models/SubscriberModel'

const MUVEN_CLIENT_ID_KEY = 'muven-client-id'

export default {
    selectSubscriber(sub:SubscriberModel):void {
        localStorage.setItem(MUVEN_CLIENT_ID_KEY, sub.publicKey)
    },
    getPublicKeyFromStorage():string {
        return localStorage.getItem(MUVEN_CLIENT_ID_KEY) || ""
    },
    hasPublicKeyInStorage():boolean {
        return !!localStorage.getItem(MUVEN_CLIENT_ID_KEY)
    },
    removeSubscriberFromStorage():void {
        localStorage.removeItem(MUVEN_CLIENT_ID_KEY)
    },
}
